<div>
  <!-- (mapClick)="clickOnMap($event)" -->
  <google-map height="500px" width="100%" [zoom]="zoom" [center]="center" [options]="options">
    <ng-container *ngFor="let record of visibleRecords">
      <map-marker
        #markerElem="mapMarker"
        [title]="record?.recordData?.branchName"
        [label]="record?.recordData?.branchAddress"
        [position]="{lat: record?.recordData?.geolocation[0], lng: record?.recordData?.geolocation[1]}"
        [options]="markerOptions"
        (mapClick)="openInfo(markerElem, record?.recordData)"
      >
      </map-marker>
      <map-info-window>
        <strong>Código: {{ infoContent?.branchCode }}</strong><br>
        <strong>Sucursal: {{ infoContent?.branchName}}</strong><br>
        <strong>{{ infoContent?.branchAddress}}</strong><br>
      </map-info-window>
    </ng-container>
  </google-map>
  <button (click)="zoomIn()">Zoom in</button>
  <button (click)="zoomOut()">Zoom out</button>
  <button (click)="logCenter()">Log center</button>
  <button (click)="addMarker()">Add marker</button>
</div>
